import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { App } from 'antd';

import { queryClient } from '@/lib/react-query';
import { axiosClient } from '@/lib/axios';
import { useTranslation } from 'react-i18next';

type SharesParams = {
  companyID?: number;
  saleShareID: number;
  counter_offer: number | null;
};

type SharesResponse = {
  message: string;
};

export const expressInterest = async ({
  companyID,
  saleShareID,
  counter_offer,
}: SharesParams): Promise<SharesResponse> => {
  const { data } = await axiosClient.post<SharesResponse>(
    `companies/${companyID}/cap-table/equities/issued-shares/for-sale/${saleShareID}/interests`,
    {
      counter_offer: counter_offer,
    },
  );
  return data;
};
type UseExpressInterestOptions = {
  companyID: number;
  saleShareID: number;
  config?: Partial<UseMutationOptions<SharesResponse, AxiosError<{ message: string }>, SharesParams>>;
  postSuccess?: () => void;
};

export const useExpressInterest = ({ companyID, saleShareID, config, postSuccess }: UseExpressInterestOptions) => {
  const { notification: toaster } = App.useApp();
  const { t } = useTranslation('common');
  return useMutation({
    onError: (error) => {
      const errorResponse = (error.response?.data as { message: string }) || {};
      toaster.error({
        message: t('somethingWentWrong'),
        description: t(errorResponse.message || error.message),
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['share-sales', companyID],
      });
      await queryClient.invalidateQueries({
        queryKey: ['share-sale', companyID, saleShareID],
      });
      toaster.success({
        message: t('interestedSuccessfully'),
        description: t('interestSentSuccessfully'),
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: expressInterest,
  });
};
